import React from "react";
import "./Footer.css";
import logo from "./Images/logo.svg";
import schoolForm from "./assest/school_form.pdf";
import collegeForm from "./assest/college_form.pdf";
import { Link, NavLink } from "react-router-dom";
import messageIcon from "./Images/eva_email-fill.png"
import callIcon from "./Images/fluent_call-12-filled.png"

export default function Footer() {
  return (
    <div className="container-fluid bg-footer">
      <div className="row row1">
        {/* col-one */}
        <div className="col-lg-3 col-md-3 col-sm-12">
          <div className="ghk-logo-footer">
            <img src={logo} />
          </div> <br />
          <p className="Heading1">
            Our school is an Institution designed to provide learning spaces and
            learning environments for the students under the guidance of the
            teachers.
          </p> <br />
          <div className="Socialmediaicons">
            <div className="Backgroundring">
              <div className="facebook"></div>
            </div>
            <div className="Backgroundring">
              <a href="https://www.linkedin.com/company/113/" />
              <div className="linkedin"></div>
            </div>
            <div className="Backgroundring">
              <div className="instagram"></div>
            </div>
            <div className="Backgroundring">
              <div className="youtube"></div>
            </div>
            <div className="Backgroundring">
              <div className="x"></div>
            </div>
          </div>
        </div>
        {/* col-two */}
        <div className="footer-cols col-lg-2 col-md-2 col-sm-12">
          <p className="footer-col-heading">QUICK LINKS</p>
          <div className="footer-about-us"><Link to='/about'>ABOUT US</Link> </div>
          <div className="footer-about-us"><Link to='/AcademicResults'>ADMISSIONS</Link></div>
          <div className="footer-about-us"><Link to='/AcademicResults'>ACADEMICS</Link> </div>
        </div>
        {/* col-three */}
        <div className="col-lg-3 col-md-3 col-sm-12">
          <div className="Sixth">
            <div className="footer-col-heading">ADMISSIONS (DOWNLOADS)</div>
            <div className="sixthdown">
              <div className="Heading">
                HIGH SCHOOL ADMISSIONS
              </div>
              <a href={schoolForm} download="school_form.pdf">
                <div className="download"></div>
              </a>
            </div>
            <div className="sixthdown">
              <div className="Heading">
                JR. COLLEGE ADMISSIONS
              </div>
              <a href={collegeForm} download="college_form.pdf">
                <div className="download download2"></div>
              </a>
            </div>
          </div>
        </div>
        {/* col-four */}
        <div className="col-lg-3 col-md-3 col-sm-12">
          <div className="Seventh">
            <div className="Seventh1">
              <div className="footer-col-heading">CONTACT US</div>
              <div className="Heading11" style={{ width: "250px" }}>
                58, Gazdhar Park, North Avenue, Santacruz (W), Mumbai – 400054 Maharashtra
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ display: "flex", flexShrink: "0", marginRight: "8px", alignItems: "center" }}>
                  <img src={callIcon} alt="callIcon" />
                </div>
                <div className="Heading1">
                  <div >+91 – 22 – 26047978 </div>
                  <div>+91 – 22 – 26047469</div>
                  <div> +91 – 82 – 96049604</div>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ display: "flex", flexShrink: "0", marginRight: "8px", alignItems: "center" }}>
                  <img src={messageIcon} alt="messageIcon" />
                </div>
                <div className="Heading1">guruhkschool@gmail.com</div>
              </div>
            </div>
          </div>
        </div>
      </div> <br /> <br />
      <hr />
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <p className="footer-copyright">
            Copyright 2019 GURU HARKRISHAN HIGH SCHOOL & JUNIOR COLLEGE OF COMMERCE. ALL RIGHTS RESERVED
          </p>
          <p className="footer-DGDose">
            Digital Dose
          </p>
        </div>
      </div>

    </div>
  );
}